import {
  LayoutDashboard, CheckSquare, Building2, Users, FileSignature, Briefcase,
  Coins, Wallet, Newspaper, FolderOpen, Settings, ShieldCheck, ScrollText, PieChart, BadgeCheck,
} from 'lucide-react';

/**
 * Persistent administration navigation. Only routes that exist today are
 * enabled; planned modules are declared with `available: false` so the shell
 * architecture is ready without faking functionality.
 */
export const ADMIN_NAV = [
  {
    section: 'Overview',
    items: [
      { label: 'Dashboard', path: '/admin', icon: LayoutDashboard, available: true },
      { label: 'Tasks & Approvals', path: '/admin/tasks', icon: CheckSquare, available: true },
    ],
  },
  {
    section: 'Operations',
    items: [
      { label: 'Projects', path: '/admin/v2/projects', icon: Building2, available: true },
      { label: 'Investors & Parties', path: '/admin/v2/parties', icon: Users, available: true },
    ],
  },
  {
    section: 'Investments',
    items: [
      { label: 'Subscriptions', path: '/admin/v2/subscriptions', icon: FileSignature, available: true },
      { label: 'Instruments', path: '/admin/instruments', icon: Briefcase, available: true },
      { label: 'Distributions', path: '/admin/v2/distributions', icon: Coins, available: true },
      { label: 'Flippex Portfolio', path: '/admin/flippex-portfolio', icon: PieChart, available: true },
    ],
  },
  {
    section: 'Management',
    items: [
      { label: 'Finance', path: '/admin/v2/finance', icon: Wallet, available: true },
      { label: 'News & Stories', path: '/admin/news', icon: Newspaper, available: true },
      { label: 'Recognition & Media', path: '/admin/recognition', icon: BadgeCheck, available: true },
      { label: 'Documents', path: '/admin/documents', icon: FolderOpen, available: false },
    ],
  },
  {
    section: 'System',
    items: [
      { label: 'Settings', path: '/admin/settings', icon: Settings, available: false },
      { label: 'Team & Admins', path: '/admin/team', icon: ShieldCheck, available: true },
      { label: 'Audit Log', path: '/admin/audit', icon: ScrollText, available: false },
    ],
  },
];

export const QUICK_CREATE = [
  { label: 'New Project', path: '/admin/v2/projects?create=1' },
  { label: 'New Investor / Party', path: '/admin/v2/parties?create=1' },
  { label: 'New Instrument', path: '/admin/instruments/new' },
  { label: 'New Subscription', path: '/admin/v2/subscriptions?create=1' },
  { label: 'Financial Entry', path: '/admin/v2/finance?create=1' },
];
